export default __webpack_public_path__ + "static/media/move_smash.7baa026c.mp3";